// import React, { useState, useRef, useEffect } from 'react';
// import { apiCall } from '@/api/apiCall';
// import { toast } from 'sonner';
// import { useApiQueue } from '@/hooks/useApiQueue';
// import { AssetsPanel } from '../../components/shared/AssetsPanel';
// import { API_CALL_TIME } from '@/constants/constant';

// // ─── Fallback Data ────────────────────────────────────────────────────────────
// const FALLBACK_PROFILE = {
//   table_key: 'al_batha_real_estate_profile',
//   title: 'Al Batha Real Estate - Profile',
//   data: {
//     project_name:    { label: 'Project Name', value: 'RIYADH_BATHA' },
//     contract_term:   { label: 'Contract Term', value: '14 years' },
//     contract_period: { start_date: '11/07/2021', end_date: '10/07/2035' },
//   },
// };

// // const FALLBACK_FLOORS = {
// const FALLBACK_FLOORS = {
//   table_key: 'al_batha_building_floors_breakdown',
//   title: 'Al Batha Building Floor Breakdown',
//   data: {
//     columns: [
//       { column_key: 'building_floor', label: 'BUILDING FLOOR', type: 'text' },
//       { column_key: 'floor_details', label: '08', type: 'group', sub_columns: [
//         { column_key: 'floor_number', label: '', type: 'text' },
//         { column_key: 'floor_type',   label: '', type: 'text' },
//       ]},
//       { column_key: 'qty', label: 'QTY', type: 'text' },
//     ],
//    rows: [
//   { floor_number: '1st FLOOR', floor_type: 'SHOPS',   qty: '197',building_rowSpan: 8 },
//   { floor_number: '2nd FLOOR', floor_type: 'SHOPS',   qty: '59 + Nesto Supermarket' },

//   // 👇 parking group start
//   { floor_number: '3rd FLOOR', floor_type: 'PARKING', qty: '1530 Parking Bays', rowSpan: 6 },
//   { floor_number: '4th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
//   { floor_number: '5th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
//   { floor_number: '6th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
//   { floor_number: '7th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
//   { floor_number: '8th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
// ],
//   },
// };

// const FALLBACK_ASSETS = {
//   table_key: 'al_batha_assets_deployed_01',
//   title: 'Al Batha Off-Street',
//   data: {
//     groups: [
//       { group_name: 'Ticket Dispenser',    group_total_qty: '3', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '3' }, { item_name: 'G100 32 Bit', qty: '-' }] },
//       { group_name: 'Ticket Verifier',     group_total_qty: '2', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '2' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
//       { group_name: "APM's",               group_total_qty: '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
//       { group_name: 'PIN Pad',             group_total_qty: '-', items: [{ item_name: 'IUP250', qty: '-' }] },
//       { group_name: 'Card Reader',         group_total_qty: '-', items: [{ item_name: 'IUR250', qty: '-' }] },
//       { group_name: 'B-Contactless',       group_total_qty: '-', items: [{ item_name: 'IUC150', qty: '-' }] },
//       { group_name: 'RFID Reader',         group_total_qty: '6', items: [] },
//       { group_name: 'IP Barrier',          group_total_qty: '5', items: [] },
//       { group_name: 'ANPR Camera',         group_total_qty: '5', items: [{ item_name: 'ARH', qty: '5' }, { item_name: 'Lumenera', qty: '-' }] },
//       { group_name: 'Sliding Gate',        group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
//       { group_name: "PND's",               group_total_qty: '-', items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
//       { group_name: 'Pound Cashier Device',group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
//       { group_name: 'Driver Device',       group_total_qty: '2', items: [{ item_name: 'CN-51', qty: '2' }] },
//       { group_name: 'Enf Device',          group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
//       { group_name: 'Validation',          group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
//       { group_name: 'Printer',             group_total_qty: '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
//       { group_name: 'Tow Truck',           group_total_qty: '-', items: [] },
//       { group_name: 'Clamp Vehicle',       group_total_qty: '-', items: [] },
//       { group_name: 'Support Vehicle',     group_total_qty: '-', items: [] },
//     ],
//   },
// };

// // ─── Helpers ──────────────────────────────────────────────────────────────────
// const groupsToFlat = (groups = []) => {
//   const result = [];
//   groups.forEach(g => {
//     result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
//     (g.items || []).forEach(item => {
//       result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
//     });
//   });
//   return result;
// };

// const flatToGroups = (flat) => {
//   const groups = [];
//   let cur = null;
//   flat.forEach(a => {
//     if (a.isCategory) {
//       if (cur) groups.push(cur);
//       cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
//     } else if (cur) {
//       cur.items.push({ item_name: a.name, qty: a.subCount || '' });
//     }
//   });
//   if (cur) groups.push(cur);
//   return groups;
// };

// // ─────────────────────────────────────────────────────────────────────────────
// const AlBatha_4 = ({ year = '', monthNumber = '', contract = '' }) => {
//   const saveTimeoutRef = useRef(null);
//   const [isSaving, setIsSaving] = useState(false);

//   const [profileTable, setProfileTable] = useState(FALLBACK_PROFILE);
//   const [floorsTable,  setFloorsTable]  = useState(FALLBACK_FLOORS);
//   const [assetsTable,  setAssetsTable]  = useState(FALLBACK_ASSETS);

//     const { enqueue } = useApiQueue();
  
//       // ── Refs for latest state (Stale State Fix) ─────────────────────────────
//   const profileRef = useRef(null);
//   const floorsRef  = useRef(null);
//   const assetsRef  = useRef(null);

//   // Sync refs with latest state
//   useEffect(() => {
//     profileRef.current = profileTable;
//   }, [profileTable]);

//   useEffect(() => {
//     floorsRef.current = floorsTable;
//   }, [floorsTable]);

//   useEffect(() => {
//     assetsRef.current = assetsTable;
//   }, [assetsTable]);
//   // ── Fetch ─────────────────────────────────────────────────────────────────
//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const response = await enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber }));
//         if (!response?.success) return;
//         const data = response?.data || [];
//         const find = (key, fb) => data.find(t => t.table_key === key) || fb;
//         setProfileTable(find('al_batha_real_estate_profile',       FALLBACK_PROFILE));
//         setFloorsTable( find('al_batha_building_floors_breakdown', FALLBACK_FLOORS));
//         setAssetsTable( find('al_batha_assets_deployed_01',           FALLBACK_ASSETS));
//       } catch (err) {
//         console.error('Fetch error:', err);
//       }
//     };
//     fetchData();
//   }, [year, monthNumber, contract]);

//   // ── Auto-save ─────────────────────────────────────────────────────────────
//   const autoSave = () => {
//     if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
//     saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
//   };

//     // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
//   const saveToAPI = async () => {
//     try {
//       setIsSaving(true);

//       const tables = [
//         { 
//           table_key: profileRef.current?.table_key, 
//           title: profileRef.current?.title, 
//           data: profileRef.current?.data 
//         },
//         { 
//           table_key: floorsRef.current?.table_key, 
//           title: floorsRef.current?.title, 
//           data: floorsRef.current?.data 
//         },
//         { 
//           table_key: assetsRef.current?.table_key, 
//           title: assetsRef.current?.title, 
//           data: assetsRef.current?.data 
//         },
//       ];

//       const response = await apiCall('POST', '/boardpack/add-tables-data', {
//         contract, 
//         year, 
//         month: monthNumber, 
//         created_by: 1,
//         tables,
//       });

//       if (!response?.success) throw new Error(response?.message || 'Save failed');
//     } catch (err) {
//       console.error('Save error:', err);
//       toast.error('Failed to save changes');
//     } finally {
//       setIsSaving(false);
//     }
//   };

//   // ── Handlers ──────────────────────────────────────────────────────────────
//   const patchProfile = (field, subField, value) => {
//     setProfileTable(prev => ({
//       ...prev,
//       data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
//     }));
//     autoSave();
//   };

//   const handleFloorsCount = (value) => {
//     setFloorsTable(prev => ({
//       ...prev,
//       data: { ...prev.data, columns: prev.data.columns.map(col => col.type === 'group' ? { ...col, label: value } : col) },
//     }));
//     autoSave();
//   };

//   const handleFloorRow = (rowIdx, field, value) => {
//     setFloorsTable(prev => ({
//       ...prev,
//       data: { ...prev.data, rows: prev.data.rows.map((row, i) => i === rowIdx ? { ...row, [field]: value } : row) },
//     }));
//     autoSave();
//   };

//   const handleAssetSubCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   const handleAssetTotalCount = (flatIdx, value) => {
//     const flat = groupsToFlat(assetsTable.data.groups).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
//     setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
//     autoSave();
//   };

//   // ── Accessors ─────────────────────────────────────────────────────────────
//   const pd  = profileTable.data;
//   const fd  = floorsTable.data;
//   const floorsCountLabel = fd.columns?.find(c => c.type === 'group')?.label || '';
//   const floorRows = fd.rows || [];
//   const flatAssets = groupsToFlat(assetsTable.data.groups);

//   return (
//     <div className="min-h-screen p-4 md:p-6 lg:p-8 bg-white">
//       {/* Title */}
//       <div className="text-center mb-4">
//         <h1 className="text-xl font-bold">{profileTable.title}</h1>
//       </div>

//       <div className="flex flex-col lg:flex-row gap-0 !border-2 !border-black p-3">

//         {/* ── Left ── */}
//         <div className="flex-1  !border-black pr-4">
//           <div className="text-[16px] font-semibold mb-4">Activities:</div>

//           {/* Project Name */}
//           <div className="flex items-center gap-2 mb-1 ml-4">
//             <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
//             <span className="text-[12px]">
//               {pd.project_name?.label}{' '}
//               <strong>
//                 <input type="text" value={pd.project_name?.value || ''}
//                   onChange={e => patchProfile('project_name', 'value', e.target.value)}
//                   className="font-bold outline-none bg-transparent !border-0 text-[12px]" />
//               </strong>
//             </span>
//           </div>

//           {/* Contract Term */}
//           <div className="flex items-center gap-2 mb-1 ml-10">
//             <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
//             {/* <span className="text-[12px] flex items-center flex-wrap gap-1"> */}
//             <span className="text-[12px]">
//               Contract term{' '}
//               <strong><input type="text" value={pd.contract_term?.value || ''}
//                 onChange={e => patchProfile('contract_term', 'value', e.target.value)}
//                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12.5" /></strong>
//               ; start date{' '}
//               <strong><input type="text" value={pd.contract_period?.start_date || ''}
//                 onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
//                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17" /></strong>
//               {' to '}
//               <strong><input type="text" value={pd.contract_period?.end_date || ''}
//                 onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
//                 className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
//             </span>
//           </div>

//           {/* Assets Deployed */}
//           <div className="flex items-center gap-2 ml-10 mb-6">
//             <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
//             <span className="text-[12px]">Assets Deployed for Car Parking</span>
//           </div>

//           {/* Building Floors Table */}
//           <div className="ml-10">
//             <table className="!border-collapse text-[11px]">
//               <thead>
//                 <tr>
//                   <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '120px' }}>
//                     BUILDING FLOOR
//                   </th>
//                   <th colSpan={2} className="!border !border-black px-3 py-1 font-bold text-center bg-white" style={{ minWidth: '160px' }}>
//                     <input type="text" value={floorsCountLabel} onChange={e => handleFloorsCount(e.target.value)}
//                       className="font-bold outline-none bg-transparent !border-0 text-center w-16 text-[11px]" />
//                   </th>
//                   <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '150px' }}>
//                     QTY
//                   </th>
//                 </tr>
//                 {/* <tr>
//                   <th className="!border !border-black px-2 py-0.5 bg-white" style={{ minWidth: '100px' }} />
//                   <th className="!border !border-black px-2 py-0.5 bg-white" style={{ minWidth: '70px' }} />
//                 </tr> */}
//               </thead>
//               <tbody>
//                 {floorRows.map((row, idx) => (
//                   <tr key={idx}>
//                     {idx === 0 ? (
//   <td
//     rowSpan={row.building_rowSpan || floorRows.length}
//     className="!border !border-black px-2  py-1 text-center align-middle"
//   >
//     <input
//       type="text"
//       value={row.building_floor || ''}
//       onChange={e => handleFloorRow(idx, 'building_floor', e.target.value)}
//       className="outline-none bg-transparent !border-0 w-full text-center text-[11px]"
//     />
//   </td>
// ) : null}
//                     <td className="!border !border-black px-2 py-1">
//                       <input type="text" value={row.floor_number || ''} onChange={e => handleFloorRow(idx, 'floor_number', e.target.value)} className="outline-none bg-transparent !border-0 w-full text-center text-[11px]" />
//                     </td>
//                     <td className="!border !border-black px-2 py-1 text-center">
//                       <input type="text" value={row.floor_type || ''} onChange={e => handleFloorRow(idx, 'floor_type', e.target.value)} className="outline-none bg-transparent !border-0 w-full text-center text-[11px]" />
//                     </td>
//                   {!row.hideQty ? (
//   <td
//     rowSpan={row.rowSpan || 1}
//     className="!border !border-black px-2 py-1 text-center align-middle"
//   >
//     <input
//       type="text"
//       value={row.qty || ''}
//       onChange={e => handleFloorRow(idx, 'qty', e.target.value)}
//       className="outline-none bg-transparent !border-0 w-full text-center font-bold text-[11px]"
//     />
//   </td>
// ) : null}
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//         </div>

//         {/* ── Right — Assets ── */}
//        <AssetsPanel
//                                    assetsTable={{ title: assetsTable.title }}
//                                    flatAssets={flatAssets}
//                                    onSubCount={handleAssetSubCount}
//                                    onTotalCount={handleAssetTotalCount}
//                                />

//       </div>

//       {/* {isSaving && (
//         <div className="fixed bottom-4 right-4 bg-blue-600 text-white text-xs px-3 py-1.5 rounded shadow-lg z-50">
//           Saving...
//         </div>
//       )} */}
//     </div>
//   );
// };

// export default AlBatha_4;



import React, { useState, useRef, useEffect } from 'react';
import { apiCall } from '@/api/apiCall';
import { toast } from 'sonner';
import { useApiQueue } from '@/hooks/useApiQueue';
import { AssetsPanel } from '../../components/shared/AssetsPanel';
import { API_CALL_TIME } from '@/constants/constant';

// ─── Fallback Data ────────────────────────────────────────────────────────────
const FALLBACK_PROFILE = {
  table_key: 'al_batha_real_estate_profile',
  title: 'Al Batha Real Estate - Profile',
  data: {
    project_name:    { label: 'Project Name', value: 'RIYADH_BATHA' },
    contract_term:   { label: 'Contract Term', value: '14 years' },
    contract_period: { start_date: '11/07/2021', end_date: '10/07/2035' },
  },
};

const FALLBACK_FLOORS = {
  table_key: 'al_batha_building_floors_breakdown',
  title: 'Al Batha Building Floor Breakdown',
  data: {
    columns: [
      { column_key: 'building_floor', label: 'BUILDING FLOOR', type: 'text' },
      { column_key: 'floor_details', label: '08', type: 'group', sub_columns: [
        { column_key: 'floor_number', label: '', type: 'text' },
        { column_key: 'floor_type',   label: '', type: 'text' },
      ]},
      { column_key: 'qty', label: 'QTY', type: 'text' },
    ],
   rows: [
  { floor_number: '1st FLOOR', floor_type: 'SHOPS',   qty: '197', building_rowSpan: 8 },
  { floor_number: '2nd FLOOR', floor_type: 'SHOPS',   qty: '59 + Nesto Supermarket' },

  // 👇 parking group start
  { floor_number: '3rd FLOOR', floor_type: 'PARKING', qty: '1530 Parking Bays', rowSpan: 6 },
  { floor_number: '4th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
  { floor_number: '5th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
  { floor_number: '6th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
  { floor_number: '7th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
  { floor_number: '8th FLOOR', floor_type: 'PARKING', qty: '', hideQty: true },
],
  },
};

const FALLBACK_ASSETS = {
  table_key: 'al_batha_assets_deployed_01',
  title: 'Al Batha Off-Street',
  data: {
    groups: [
      { group_name: 'Ticket Dispenser',    group_total_qty: '3', items: [{ item_name: 'DIP G100', qty: '-' }, { item_name: 'G100 64 Bit', qty: '3' }, { item_name: 'G100 32 Bit', qty: '-' }] },
      { group_name: 'Ticket Verifier',     group_total_qty: '2', items: [{ item_name: 'EV DIP G100', qty: '-' }, { item_name: 'EV G100 64 Bit', qty: '2' }, { item_name: 'EV G100 32 Bit', qty: '-' }] },
      { group_name: "APM's",               group_total_qty: '-', items: [{ item_name: 'APM ETS-70', qty: '-' }, { item_name: 'APM ETS-100', qty: '-' }] },
      { group_name: 'PIN Pad',             group_total_qty: '-', items: [{ item_name: 'IUP250', qty: '-' }] },
      { group_name: 'Card Reader',         group_total_qty: '-', items: [{ item_name: 'IUR250', qty: '-' }] },
      { group_name: 'B-Contactless',       group_total_qty: '-', items: [{ item_name: 'IUC150', qty: '-' }] },
      { group_name: 'RFID Reader',         group_total_qty: '6', items: [] },
      { group_name: 'IP Barrier',          group_total_qty: '5', items: [] },
      { group_name: 'ANPR Camera',         group_total_qty: '5', items: [{ item_name: 'ARH', qty: '5' }, { item_name: 'Lumenera', qty: '-' }] },
      { group_name: 'Sliding Gate',        group_total_qty: '-', items: [{ item_name: 'RIGHT', qty: '-' }, { item_name: 'LEFT', qty: '-' }] },
      { group_name: "PND's",               group_total_qty: '-', items: [{ item_name: 'TPAL BNA-Large', qty: '-' }, { item_name: 'T-PAL TX', qty: '-' }, { item_name: 'T-PAL V2', qty: '-' }] },
      { group_name: 'Pound Cashier Device',group_total_qty: '-', items: [{ item_name: 'CN-50', qty: '-' }] },
      { group_name: 'Driver Device',       group_total_qty: '2', items: [{ item_name: 'CN-51', qty: '2' }] },
      { group_name: 'Enf Device',          group_total_qty: '-', items: [{ item_name: 'Oukitel WP2', qty: '-' }, { item_name: 'Doogee V10', qty: '-' }] },
      { group_name: 'Validation',          group_total_qty: '-', items: [{ item_name: 'Lenova Tablet', qty: '-' }] },
      { group_name: 'Printer',             group_total_qty: '-', items: [{ item_name: 'PR-3', qty: '-' }, { item_name: 'SEWOO', qty: '-' }, { item_name: 'BIXOLON', qty: '-' }] },
      { group_name: 'Tow Truck',           group_total_qty: '-', items: [] },
      { group_name: 'Clamp Vehicle',       group_total_qty: '-', items: [] },
      { group_name: 'Support Vehicle',     group_total_qty: '-', items: [] },
    ],
  },
};

// ─── Helpers ──────────────────────────────────────────────────────────────────
const groupsToFlat = (groups = []) => {
  const result = [];
  groups.forEach(g => {
    result.push({ name: g.group_name || '', isCategory: true, subCount: '', totalCount: String(g.group_total_qty ?? '-') });
    (g.items || []).forEach(item => {
      result.push({ name: item.item_name || '', isCategory: false, subCount: String(item.qty ?? '-'), totalCount: '' });
    });
  });
  return result;
};

const flatToGroups = (flat) => {
  const groups = [];
  let cur = null;
  flat.forEach(a => {
    if (a.isCategory) {
      if (cur) groups.push(cur);
      cur = { group_name: a.name, group_total_qty: a.totalCount || '', items: [] };
    } else if (cur) {
      cur.items.push({ item_name: a.name, qty: a.subCount || '' });
    }
  });
  if (cur) groups.push(cur);
  return groups;
};

// ─────────────────────────────────────────────────────────────────────────────
const AlBatha_4 = ({ year = '', month = '', monthNumber = '', contract = '' }) => {
  const saveTimeoutRef = useRef(null);
  const [isSaving, setIsSaving] = useState(false);
  const hasFetchedRef = useRef(false);

  // 🔥 State for second API (parking bays)
  const [parkingBaysData, setParkingBaysData] = useState(null);

  const [profileTable, setProfileTable] = useState(FALLBACK_PROFILE);
  const [floorsTable,  setFloorsTable]  = useState(FALLBACK_FLOORS);
  const [assetsTable,  setAssetsTable]  = useState(FALLBACK_ASSETS);

  const { enqueue } = useApiQueue();

  // 🔥 Effective total parking bays - second API se aayega
  const effectiveTotalBays = parkingBaysData?.total_bays ?? 1530;

  // ── Refs for latest state (Stale State Fix) ─────────────────────────────
  const profileRef = useRef(null);
  const floorsRef  = useRef(null);
  const assetsRef  = useRef(null);

  // Sync refs with latest state
  useEffect(() => {
    profileRef.current = profileTable;
  }, [profileTable]);

  useEffect(() => {
    floorsRef.current = floorsTable;
  }, [floorsTable]);

  useEffect(() => {
    assetsRef.current = assetsTable;
  }, [assetsTable]);

  // ── Fetch BOTH APIs ─────────────────────────────────────────────────────────────────
  useEffect(() => {
    if (hasFetchedRef.current) return;
    hasFetchedRef.current = true;
    fetchAllData();
  }, [year, month, monthNumber, contract]);

  const fetchAllData = async () => {
    try {
      // 🔥 Second API params - 'type' not 'value'
      const secondApiParams = {
        contract: "1501002",
        year: year,
        month: month,     // using 'month' (string like "Oct")
        type: "off_street"
      };
      
      const [firstApiResponse, secondApiResponse] = await Promise.all([
        enqueue(() => apiCall('GET', '/boardpack/get-tables-data', { year, contract, month: monthNumber })),
        enqueue(() => apiCall('GET', '/boardpack/parking/bays', secondApiParams))
      ]);

      // Process first API response
      if (firstApiResponse?.success) {
        const data = firstApiResponse?.data || [];
        const find = (key, fb) => data.find(t => t.table_key === key) || fb;
        setProfileTable(find('al_batha_real_estate_profile',       FALLBACK_PROFILE));
        setFloorsTable( find('al_batha_building_floors_breakdown', FALLBACK_FLOORS));
        setAssetsTable( find('al_batha_assets_deployed_01',        FALLBACK_ASSETS));
      }

      // 🔥 Process second API response for parking bays
      if (secondApiResponse?.success && secondApiResponse?.data) {
        setParkingBaysData(secondApiResponse.data);
      } else {
        console.warn("Second API failed:", secondApiResponse?.message);
        setParkingBaysData(null);
      }
      
    } catch (err) {
      console.error('Fetch error:', err);
    }
  };

  // ── Auto-save ─────────────────────────────────────────────────────────────
  const autoSave = () => {
    if (saveTimeoutRef.current) clearTimeout(saveTimeoutRef.current);
    saveTimeoutRef.current = setTimeout(saveToAPI, API_CALL_TIME);
  };

  // ── Fixed saveToAPI using Refs ────────────────────────────────────────────
  const saveToAPI = async () => {
    try {
      setIsSaving(true);

      const tables = [
        { 
          table_key: profileRef.current?.table_key, 
          title: profileRef.current?.title, 
          data: profileRef.current?.data 
        },
        { 
          table_key: floorsRef.current?.table_key, 
          title: floorsRef.current?.title, 
          data: floorsRef.current?.data 
        },
        { 
          table_key: assetsRef.current?.table_key, 
          title: assetsRef.current?.title, 
          data: assetsRef.current?.data 
        },
      ];

      const response = await apiCall('POST', '/boardpack/add-tables-data', {
        contract, 
        year, 
        month: monthNumber, 
        created_by: 1,
        tables,
      });

      if (!response?.success) throw new Error(response?.message || 'Save failed');
    } catch (err) {
      console.error('Save error:', err);
      toast.error('Failed to save changes');
    } finally {
      setIsSaving(false);
    }
  };

  // ── Handlers ──────────────────────────────────────────────────────────────
  const patchProfile = (field, subField, value) => {
    setProfileTable(prev => ({
      ...prev,
      data: { ...prev.data, [field]: subField ? { ...prev.data[field], [subField]: value } : value },
    }));
    autoSave();
  };

  const handleFloorsCount = (value) => {
    setFloorsTable(prev => ({
      ...prev,
      data: { ...prev.data, columns: prev.data.columns.map(col => col.type === 'group' ? { ...col, label: value } : col) },
    }));
    autoSave();
  };

  const handleFloorRow = (rowIdx, field, value) => {
    setFloorsTable(prev => ({
      ...prev,
      data: { ...prev.data, rows: prev.data.rows.map((row, i) => i === rowIdx ? { ...row, [field]: value } : row) },
    }));
    autoSave();
  };

  const handleAssetSubCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, subCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  const handleAssetTotalCount = (flatIdx, value) => {
    const flat = groupsToFlat(assetsRef.current?.data?.groups || []).map((a, i) => i === flatIdx ? { ...a, totalCount: value } : a);
    setAssetsTable(prev => ({ ...prev, data: { ...prev.data, groups: flatToGroups(flat) } }));
    autoSave();
  };

  // ── Accessors ─────────────────────────────────────────────────────────────
  const pd  = profileTable.data;
  const fd  = floorsTable.data;
  const floorsCountLabel = fd.columns?.find(c => c.type === 'group')?.label || '';
  const floorRows = fd.rows || [];
  const flatAssets = groupsToFlat(assetsTable.data.groups);

  return (
    <div className="min-h-screen p-8 bg-white">
      {/* Title */}
      <div className="text-center mb-4">
        <h1 className="text-xl font-bold">{profileTable.title}</h1>
      </div>

      <div className="flex flex-row gap-0 !border-2 !border-black p-3">

        {/* ── Left ── */}
        <div className="flex-1  !border-black pr-4">
          <div className="text-[16px] font-semibold mb-4">Activities:</div>

          {/* Project Name - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-4">
            <div className="w-4 h-4 !border-2 !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              {pd.project_name?.label}{' '}
              <strong>
                <input type="text" value={pd.project_name?.value || ''}
                  onChange={e => patchProfile('project_name', 'value', e.target.value)}
                  className="font-bold outline-none bg-transparent !border-0 text-[12px]" />
              </strong>
            </span>
          </div>

          {/* Contract Term - Editable */}
          <div className="flex items-center gap-2 mb-1 ml-10">
            <div className="w-3 h-3 !border !border-blue-600 flex-shrink-0" />
            <span className="text-[12px]">
              Contract term{' '}
              <strong><input type="text" value={pd.contract_term?.value || ''}
                onChange={e => patchProfile('contract_term', 'value', e.target.value)}
                className="font-bold outline-none bg-transparent !border-0 text-[12px] w-12.5" /></strong>
              ; start date{' '}
              <strong><input type="text" value={pd.contract_period?.start_date || ''}
                onChange={e => patchProfile('contract_period', 'start_date', e.target.value)}
                className="font-bold outline-none bg-transparent !border-0 text-[12px] w-17" /></strong>
              {' to '}
              <strong><input type="text" value={pd.contract_period?.end_date || ''}
                onChange={e => patchProfile('contract_period', 'end_date', e.target.value)}
                className="font-bold outline-none bg-transparent !border-0 text-[12px] w-24" /></strong>
            </span>
          </div>

          {/* Assets Deployed */}
          <div className="flex items-center gap-2 ml-10 mb-6">
            <div className="w-3 h-3 rounded-full bg-red-500 flex-shrink-0" />
            <span className="text-[12px]">Assets Deployed for Car Parking</span>
          </div>

          {/* Building Floors Table */}
          <div className="ml-10">
            <table className="!border-collapse text-[11px]">
              <thead>
                <tr>
                  <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '120px' }}>
                    BUILDING FLOOR
                  </th>
                  <th colSpan={2} className="!border !border-black px-3 py-1 font-bold text-center bg-white" style={{ minWidth: '160px' }}>
                    <input type="text" value={floorsCountLabel} onChange={e => handleFloorsCount(e.target.value)}
                      className="font-bold outline-none bg-transparent !border-0 text-center w-16 text-[11px]" />
                  </th>
                  <th rowSpan={2} className="!border !border-black px-3 py-1 font-bold text-center align-middle bg-white" style={{ minWidth: '150px' }}>
                    QTY
                  </th>
                </tr>
              </thead>
              <tbody>
                {floorRows.map((row, idx) => {
                  const isParkingRow = row.floor_type === 'PARKING' && row.qty?.includes('Parking Bays');
                  
                  return (
                    <tr key={idx}>
                      {idx === 0 ? (
                        <td
                          rowSpan={row.building_rowSpan || floorRows.length}
                          className="!border !border-black px-2 py-1 text-center align-middle"
                        >
                          <input
                            type="text"
                            value={row.building_floor || ''}
                            onChange={e => handleFloorRow(idx, 'building_floor', e.target.value)}
                            className="outline-none bg-transparent !border-0 w-full text-center text-[11px]"
                          />
                        </td>
                      ) : null}
                      <td className="!border !border-black px-2 py-1">
                        <input type="text" value={row.floor_number || ''} onChange={e => handleFloorRow(idx, 'floor_number', e.target.value)} className="outline-none bg-transparent !border-0 w-full text-center text-[11px]" />
                      </td>
                      <td className="!border !border-black px-2 py-1 text-center">
                        <input type="text" value={row.floor_type || ''} onChange={e => handleFloorRow(idx, 'floor_type', e.target.value)} className="outline-none bg-transparent !border-0 w-full text-center text-[11px]" />
                      </td>
                      {!row.hideQty ? (
                        <td
                          rowSpan={row.rowSpan || 1}
                          className="!border !border-black px-2 py-1 text-center align-middle"
                        >
                          {isParkingRow ? (
                            // 🔥 READ-ONLY - Second API se aaya hai
                            <input
                              type="text"
                              value={`${effectiveTotalBays} Parking Bays`}
                              readOnly
                              disabled
                              className="outline-none bg-transparent !border-0 w-full text-center font-bold text-[11px] cursor-default"
                            />
                          ) : (
                            <input
                              type="text"
                              value={row.qty || ''}
                              onChange={e => handleFloorRow(idx, 'qty', e.target.value)}
                              className="outline-none bg-transparent !border-0 w-full text-center font-bold text-[11px]"
                            />
                          )}
                        </td>
                      ) : null}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>

        {/* ── Right — Assets ── */}
        <AssetsPanel
          assetsTable={{ title: assetsTable.title }}
          flatAssets={flatAssets}
          onSubCount={handleAssetSubCount}
          onTotalCount={handleAssetTotalCount}
        />

      </div>
    </div>
  );
};

export default AlBatha_4;